package pl.decks.personal.components.widgets.mode

import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.vars.animation.TransitionDurationVars
import com.varabyte.kobweb.silk.theme.colors.palette.border
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.LineStyle
import pl.decks.personal.styles.SiteLayout

object ModeInputStylesheet {
    object Vars {
        val borderRadius by StyleVariable<CSSLengthOrPercentageNumericValue>(SiteLayout.Rounding.none)
        val borderWidth by StyleVariable<CSSLengthNumericValue>(SiteLayout.Line.Hairline)

        val innerPaddingTopBottom by StyleVariable<CSSLengthOrPercentageNumericValue>(SiteLayout.Space.Relative.XSmall)
        val innerPaddingLeftRight by StyleVariable<CSSLengthOrPercentageNumericValue>(SiteLayout.Space.Relative.Small)

        val textColor by StyleVariable<Color>()
        val colorTransitionDuration by StyleVariable(TransitionDurationVars.Slow.value())

        val backgroundColor by StyleVariable<Color>()
        val backgroundTransitionDuration by StyleVariable(TransitionDurationVars.Fast.value())

        val borderColor by StyleVariable<Color>()
        val borderColorTransitionDuration by StyleVariable(TransitionDurationVars.Slow.value())
    }

    val Input = CssStyle.base {
        Modifier
            .overflow(Overflow.Clip)
            .borderRadius(Vars.borderRadius.value())
            .alignItems(AlignItems.Stretch)
            .border(
                width = Vars.borderWidth.value(),
                style = LineStyle.Solid,
                color = Vars.borderColor.value(colorMode.toPalette().border),
            )
            .transition(
                Transition.of(
                    "border-color",
                    duration = Vars.borderColorTransitionDuration.value(),
                    timingFunction = TransitionTimingFunction.EaseInOut,
                )
            )
    }

    val Option = CssStyle.base {
        val palette = colorMode.toPalette()
        Modifier
            .padding(
                leftRight = Vars.innerPaddingLeftRight.value(),
                topBottom = Vars.innerPaddingTopBottom.value(),
            )
            .color(Vars.textColor.value(palette.color))
            .backgroundColor(Vars.backgroundColor.value(Colors.Transparent))
            .transition(
                Transition.of(
                    "background-color",
                    duration = Vars.backgroundTransitionDuration.value(),
                    timingFunction = TransitionTimingFunction.EaseInOut,
                ),
                Transition.of(
                    "color",
                    duration = Vars.colorTransitionDuration.value(),
                    timingFunction = TransitionTimingFunction.EaseInOut,
                ),
            )
    }
}
